interface ClickEventDetails {
  event_nom: string;
  event_detail_1: string;
  event_detail_2: string;
}

const buildClickEvent = (details: ClickEventDetails, trackingContext?: string) => ({
  event_id: 'clic',
  event_categorie: 'clic',
  event_metier: 'espace client placement',
  ...details,
  ...(trackingContext && { event_detail_3: trackingContext }),
});

export default buildClickEvent;
